import { baseApi } from '@/services'
import { Address } from '@/types/unlock'

export const addressApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAddressByExternalId: builder.query<Address, string>({
      query: (externalId) => `v2/address/${externalId}/`,
      providesTags: ['Address'],
    }),

    updateAddress: builder.mutation<Address, Partial<Address>>({
      query: (body) => ({
        method: 'PATCH',
        url: `v2/address/${body.uuid}/`,
        body,
      }),
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'AutomatedApplicationExceptions',
        'AtypicalityCheckCalcs',
        'ApplicationGuidelines',
        'ApplicationCalcs',
        'Address',
        'PropertyV2',
        'MaxActions',
        'Alert',
        'ApplicationProfiles',
      ],
    }),
    createAddress: builder.mutation<Address, { address: Partial<Address> }>({
      query: ({ address }) => ({
        url: 'v2/address/',
        method: 'POST',
        body: address,
      }),
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'ApplicationGuidelines',
        'ApplicationProfiles',
        'ApplicationCalcs',
        'Address',
        'PropertyV2',
        'MaxActions',
      ],
    }),
  }),
})

export const {
  useGetAddressByExternalIdQuery,
  useUpdateAddressMutation,
  useCreateAddressMutation,
} = addressApi
